import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Login from "../Pages/Public/Login";
import MFAVerify from "../Pages/Public/MFAVerify";

const PublicRoutes = () => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/mfa-verify" element={<MFAVerify />} />
      <Route path="*" element={<Navigate to="/login" />} />
    </Routes>
  );
};

export default PublicRoutes;
